export enum GeneralPopupType {
  History = 'history',
  Display = 'display',
  EmailHistory = 'emailHistory'
}

export enum VbtDocumentType {
  OutgoingInvoice = 'OutgoingInvoice',
  IncomingInvoice = 'IncomingInvoice',
  EArchiveInvoice = 'OutgoingEArchiveInvoice',
  MyCustomIncomingInvoice = 'MyCustomIncomingInvoice',
  MigratedOutgoingInvoice = 'MigratedOutgoingInvoice',
  MigratedIncomingInvoice = 'MigratedIncomingInvoice',
  OutgoingDespatchAdvice = 'OutgoingDespatchAdvice',
  IncomingDespatchAdvice = 'IncomingDespatchAdvice',
  MyCustomIncomingDespatchAdvice = 'MyCustomIncomingDespatchAdvice',
  OutgoingReceiptAdvice = 'OutgoingReceiptAdvice',
  IncomingReceiptAdvice = 'IncomingReceiptAdvice',
  OutgoingCreditNote = 'OutgoingCreditNote',
  OutgoingSMM = 'OutgoingSMM',
  OutgoingBill = 'OutgoingBill',
  HwTicket = 'HwTicket',
  HwPassengerList = 'HwPassengerList',
  EvTicket = 'EvTicket',
  MigratedOutgoingDespatchAdvice = 'MigratedOutgoingDespatchAdvice',
  MigratedIncomingDespatchAdvice = 'MigratedIncomingDespatchAdvice',
  OutgoingExpenseVoucher = 'OutgoingExpenseVoucher',
}

export enum DocumentType {
  OutgoingInvoice = 'OutgoingInvoice',
  IncomingInvoice = 'IncomingInvoice',
  EArchiveInvoice = 'OutgoingEArchiveInvoice',
  MyCustomIncomingInvoice = 'MyCustomIncomingInvoice',
  MigratedOutgoingInvoice = 'MigratedOutgoingInvoice',
  MigratedIncomingInvoice = 'MigratedIncomingInvoice',
  OutgoingDespatchAdvice = 'OutgoingDespatchAdvice',
  IncomingDespatchAdvice = 'IncomingDespatchAdvice',
  MyCustomIncomingDespatchAdvice = 'MyCustomIncomingDespatchAdvice',
  OutgoingReceiptAdvice = 'OutgoingReceiptAdvice',
  IncomingReceiptAdvice = 'IncomingReceiptAdvice',
  OutgoingCreditNote = 'OutgoingCreditNote',
  OutgoingSMM = 'OutgoingSMM',
  HwTicket = 'HwTicket',
  HwPassengerList = 'HwPassengerList',
  EvTicket = 'EvTicket',
  SuspendedIncomingInvoice = 'SuspendedIncomingInvoice',
  MigratedOutgoingDespatchAdvice = 'MigratedOutgoingDespatchAdvice',
  MigratedIncomingDespatchAdvice = 'MigratedIncomingDespatchAdvice',
  TicketReport = 'TicketReport',
  PassengerListReport = "PassengerListReport",
  OutgoingBill = 'OutgoingBill',
  EInvoice = 'EInvoice',
  ArchiveInvoice = 'ArchiveInvoice',
  AwTicket = 'AwTicket',
  OutgoingExpenseVoucher = 'OutgoingExpenseVoucher'
}

export enum VbtDocumentTypeName {
  OutgoingInvoice = 'Giden Fatura',
  IncomingInvoice = 'Gelen Fatura',
  EArchiveInvoice = 'E-Arşiv Fatura',
  MigratedOutgoingInvoice = 'Aktarılan Giden Fatura',
  MigratedIncomingInvoice = 'Aktarılan Gelen Fatura',
  OutgoingDespatchAdvice = 'Giden İrsaliye',
  IncomingDespatchAdvice = 'Gelen İrsaliye',
  OutgoingReceiptAdvice = 'Giden İrsaliye Yanıtı',
  IncomingReceiptAdvice = 'Gelen İrsaliye Yanıtı',
  OutgoingCreditNote = 'Müstahsil Makbuzu',
  OutgoingSMM = 'E-Serbest Meslek Makbuzu',
  EarchiveReport = 'E-Arşiv Fatura',
  SmmReceipt = 'Smm Makbuzu',
  Mustahsil = 'Müstahsil',
  HwTicket = 'Karayolu Bileti',
  HwPassengerList = 'Karayolu Yolcu Listesi',
  EvTicket = 'Etkinlik Bileti',
  MigratedOutgoingDespatchAdvice = 'Aktarılan Giden İrsaliye',
  MigratedIncomingDespatchAdvice = 'Aktarılan Gelen İrsaliye',
}

export enum DocumentTypeName {
  OutgoingInvoice = 'Giden Fatura',
  IncomingInvoice = 'Gelen Fatura',
  EArchiveInvoice = 'E-Arşiv Fatura',
  MigratedOutgoingInvoice = 'Aktarılan Giden Fatura',
  MigratedIncomingInvoice = 'Aktarılan Gelen Fatura',
  OutgoingDespatchAdvice = 'Giden İrsaliye',
  IncomingDespatchAdvice = 'Gelen İrsaliye',
  OutgoingReceiptAdvice = 'Giden İrsaliye Yanıtı',
  IncomingReceiptAdvice = 'Gelen İrsaliye Yanıtı',
  OutgoingCreditNote = 'Müstahsil Makbuzu',
  OutgoingSMM = 'E-Serbest Meslek Makbuzu',
  EarchiveReport = 'E-Arşiv Fatura',
  SmmReceipt = 'Smm Makbuzu',
  Mustahsil = 'Müstahsil',
  HwTicket = 'Karayolu Bileti',
  HwPassengerList = 'Karayolu Yolcu Listesi',
  EvTicket = 'Etkinlik Bileti',
  MigratedOutgoingDespatchAdvice = 'Aktarılan Giden İrsaliye',
  MigratedIncomingDespatchAdvice = 'Aktarılan Gelen İrsaliye',
  OutgoingBill = 'E-Adisyon',
  AwTicket = "Havayolu Bileti",
  ExpenseVoucher = "E-Gider Pusulası",
}

export enum OperationType {
  Success = 'Başarılı',
  Warning = 'Uyarı',
  Error = 'Hata',
  None = 'İşlem Yok'
}

export enum GeneralPopupActionType {
  None = '',
  DocumentXML = 'DocumentXML',
  EnvelopeXML = 'EnvelopeXML',
  PDF = 'PDF',
  Archive = 'Archive',
  GIB = 'GIB',
  Delete = 'Delete',
  ErpPorcessed = 'ErpPorcessed',
  ApproveOrReject = 'ApproveOrReject',
  CreateReport = 'CreateReport',
  Canceled = 'Canceled',
  Reply = 'Reply',
  DynamicWorkflowPendingStatus = 'DynamicWorkflowPendingStatus',
  Description = 'Description',
  Objected = 'Objected'
}

export enum DocumentColumnsType {
  OutgoingInvoice = 1,
  IncomingInvoice = 2,
  EarchiveInvoice = 3,
  OutgoingDespatchAdvice = 4,
  IncomingDespatchAdvice = 5,
  ESMM = 6,
  CreditNote = 7,
  MigratedOutgoingInvoice = 8,
  MigratedIncomingInvoice = 9,
  MyCustomIncomingInvoice = 10,
  MyCustomIncomingDespatchAdvice = 11,
  HwTicket = 12,
  HwPassengerList = 13,
  EvTicket = 14,
  SuspendedInvoice = 15,
  MigratedOutgoingDespatchAdvice = 16,
  MigratedIncomingDespatchAdvice = 17,
  Bill = 18,
  AwTicket = 1014,
  IncomingSuspendedInvoice = 19,
  ExpenseVoucher = 20
}

export enum AgGridColumnType {
  Number = 'number',
  String = 'string',
  Decimal = 'decimal',
  Bool = 'bool',
  DateTime = 'dateTime',
  Date = 'date'
}

export enum AgGridPinnedType {
  None = '',
  Left = 'left',
  Right = 'right'
}

export enum AgGridButtonActionType {
  History = 'history',
  Display = 'display',
  EmailHistory = 'emailHistory',
  ReplyDisplay = 'replyDisplay',
  EnvolopeXml = 'envolopeXml',
  DocumentXml = 'documentXml',
  Pdf = 'pdf',
  PdfOneByOne = 'pdfOneByOne',
  ViewPdf = 'viewPdf',
  LandscapePdf = 'landscapePdf',
  PortraitPdf = 'portraitPdf',
  Email = 'email',
  IsArchived = 'isArchived',
  IsRead = 'isRead',
  IsErpProcessed = 'isErpProcessed',
  SendGIB = 'sendGIB',
  ReSendGIB = 'reSendGIB',
  Edit = 'edit',
  CreateCopyDocument = 'createCopyDocument',
  Delete = 'delete',
  InWorkFlowDirect = 'inWorkFlowDirect',
  InWorkFlowStatus = 'inWorkFlowStatus',
  Description = 'description',
  AdditionalDocument = 'additionalDocument',
  InvoiceApproveOrReject = 'invoiceApproveOrReject',
  IsCanceled = 'isCanceled',
  CreateReport = 'createReport',
  DespatchAdviceReply = 'despatchAdviceReply',
  EArchiveReportDownload = 'eArchiveReportDownload',
  EArchiveReportTrash = 'eArchiveReportTrash',
  EArchiveReportInvoiceDisplay = 'eArchiveReportInvoiceDisplay',
  CurrentDefinitionCustomerUpdate = 'currentDefinitionCustomerUpdate',
  CurrentDefinitionCustomerDelete = 'currentDefinitionCustomerDelete',
  CurrentGroupDefinitionhistory = 'currentGroupDefinitionhistory',
  CurrentGroupDefinitionAddCurrent = 'currentGroupDefinitionAddCurrent',
  CurrentGroupDefinitionCurrentAccounts = 'currentGroupDefinitionCurrentAccounts',
  CurrentGroupDefinitionCurrentAccountsRemoveFromTheGroup = 'currentGroupDefinitionCurrentAccountsRemoveFromTheGroup',
  CurrentGroupDefinitionUpdate = 'currentGroupDefinitionUpdate',
  CurrentGroupDefinitionDelete = 'currentGroupDefinitionDelete',
  BankAccountUpdate = 'bankAccountUpdate',
  BankAccountDelete = 'bankAccountDelete',
  MenuDefinitionUpdate = 'menuDefinitionUpdate',
  MenuDefinitionActionAdd = 'menuDefinitionActionAdd',
  MenuDefinitionActionDelete = 'menuDefinitionActionDelete',
  ActionDefinitionUpdate = 'actionDefinitionUpdate',
  ActionDefinitionDelete = 'actionDefinitionDelete',
  InvoiceNumberManagerUpdate = 'invoiceNumberManagerUpdate',
  InvoiceNumberManagerDelete = 'invoiceNumberManagerDelete',
  FirmBranchUpdate = 'firmBranchUpdate',
  FirmBranchDelete = 'firmBranchDelete',
  RoleDefinitionDelete = 'roleDefinitionDelete',
  RoleDefinitionActionAdd = 'roleDefinitionActionAdd',
  FirmBranchAdd = 'firmBranchAdd',
  FirmUpdate = 'firmUpdate',
  FirmDelete = 'firmDelete',
  FirmNotificationDelete = 'firmNotificationDelete',
  FirmXsltUpdate = 'firmXsltUpdate',
  FirmXsltDelete = 'firmXsltDelete',
  FirmXsltDownload = 'firmXsltDownload',
  UserDefinitionFirmAdd = 'userDefinitionFirmAdd',
  UserDefinitionBranchAdd = 'userDefinitionBranchAdd',
  UserDefinitionUpdate = 'userDefinitionUpdate',
  UserDefinitionDelete = 'userDefinitionDelete',
  UserDefinitionRoleAdd = 'userDefinitionRoleAdd',
  UserDefinitionActionAdd = 'userDefinitionActionAdd',
  ReportDownloadFile = 'reportDownloadFile',
  ReportEmailSend = 'reportEmailSend',
  IncomingProxyEnvelopeHistory = "incomingProxyEnvelopeHistory",
  IncomingProxyEnvelopeDownload = "incomingProxyEnvelopeDownload",
  DraftDocumentSelect = 'draftDocumentSelect',
  DraftDocumentDelete = 'draftDocumentDelete',
  CustomerCRMUpdate = 'customerCRMUpdate',
  CustomerCRMDelete = 'customerCRMDelete',
  BankUpdate = 'bankUpdate',
  BankDelete = 'bankDelete',
  BranchArea = 'branchArea',
  BranchUpdate = 'branchUpdate',
  BranchDelete = 'branchDelete',
  ReleaseSuspendedEnvelope = 'releaseSuspendedEnvelope',
  RejectSuspendedEnvelope = 'rejectSuspendedEnvelope',
  DisplayIncomingInvoiceInformation = 'displayIncomingInvoiceInformation',
  HistoryOfIncomingInvoiceInformation = 'historyOfIncomingInvoiceInformation',
  DownloadIncomingInvoice = "downloadIncomingInvoice",
  DownloadIncomingEnvelope = "downloadIncomingEnvelope",
  DownloadOutgoingSystemResponse = 'downloadOutgoingSystemResponse',
  DownloadOutgoingApplicationResponse = 'downloadOutgoingApplicationResponse',
  DownloadIncomingGIBSystemResponse = 'downloadIncomingGIBSystemResponse',
  DownloadIncomingRCVSystemResponse = 'downloadIncomingRCVSystemResponse',
  DisplayOutgoingInvoiceInformation = 'displayOutgoingInvoiceInformation',
  HistoryOfOutgoingInvoiceInformation = 'historyOfOutgoingInvoiceInformation',
  DownloadOutgoingInvoice = "downloadIncomingInvoice",
  DownloadOutgoingEnvelope = "downloadOutgoingEnvelope",
  DownloadIncomingApplicationResponse = 'downloadIncomingApplicationResponse',
  DisplayDespatchAdviceInfoInformation = 'displayDespatchAdviceInfoInformation',
  HistoryOfDespatchAdviceInvoiceInformation = 'historyOfDespatchAdviceInvoiceInformation',
  DownloadDespatchAdvice = "downloadDespatchAdvice",
  DownloadDespatchAdviceIncomingEnvelope = "downloadDespatchAdviceIncomingEnvelope",
  DownloadDespatchAdviceOutgoingEnvelope = "downloadDespatchAdviceOutgoingEnvelope",
  DownloadDespatchAdviceOutgoingSystemResponse = "downloadDespatchAdviceOutgoingSystemResponse",
  DownloadDespatchAdviceOutgoingReceiptAdvice = "downloadDespatchAdviceOutgoingReceiptAdvice",
  DownloadDespatchAdviceIncomingReceiptAdvice = "downloadDespatchAdviceIncomingReceiptAdvice",
  DownloadDespatchAdviceIncomingGIBSystemResponse = "downloadDespatchAdviceIncomingGIBSystemResponse",
  DownloadDespatchAdviceIncomingRCVSystemResponse = "downloadDespatchAdviceIncomingRCVSystemResponse",
  DisplayApplicationLogHistory = 'displayApplicationLogHistory',
  HistoryOfIncomingEnvelopeInformation = 'historyOfIncomingEnvelopeInformation',
  HistoryOfOutgoingEnvelopeInformation = 'historyOfOutgoingEnvelopeInformation',
  DisplayRequestResponseLog = 'displayRequestResponseLog',
  DownloadRequestResponseLog = 'downloadRequestResponseLog',
  RefreshCacheManager = 'refreshCacheManager',
  IsObjected = 'isObjected',
  CompleteCancelProcess = 'completeCancelProcess',
  CompleteObjectProcess = 'completeObjectProcess',
  ReturnIncomingInvoice = 'returnIncomingInvoice',
  UpdateBAExchangeRate = "updateBAExchangeRate",
  UpdateBSExchangeRate = "updateBSExchangeRate",
  TicketReportDownload = "ticketReportDownload",
  TicketReportView = "ticketReportView",
  TicketReportDownloadPdf = 'ticketReportDownloadPdf',
  FirmServicesDelete = 'firmServicesDelete',
  DocumentProcess = 'documentProcess',
  ChangeWorkflowName = 'changeWorkflowName',
  AddCredit = "addCredit",
  GetTransactions = "getTransactions",
}

export enum UserReportSourcePageType {
  OutgoingInvoice = 'OutgoingInvoice',
  IncomingInvoice = 'IncomingInvoice',
  EarchiveInvoice = 'OutgoingEarchiveInvoice',
  OutgoingDespatchAdvice = 'OutgoingDespatchAdvice',
  IncomingDespatchAdvice = 'IncomingDespatchAdvice',
}

export enum PdfType {
  Landscape = 'Landscape',
  Portrait = 'Portrait'
}

export enum UserPageFilterType {
  OutgoingInvoice = 1,
  IncomingInvoice = 2,
  EArchiveInvoice = 3,
  OutgoingDespatchAdvice = 4,
  IncomingDespatchAdvice = 5,
  ESMM = 6,
  CreditNote = 7,
  MigratedOutgoingInvoice = 8,
  MigratedIncomingInvoice = 9,
  MyCustomIncomingInvoice = 10,
  MyCustomIncomingDespatchAdvice = 11,
  HwTicket = 12,
  HwPassengerList = 13,
  EvTicket = 14,
  SuspendedIncomingInvoice = 15,
  MigratedOutgoingDespatchAdvice = 16,
  MigratedIncomingDespatchAdvice = 17,
  Bill = 18,
  AwTicket = 19,
  ExpenseVoucher = 20
}

export enum CommonPageSourceType {
  IncomingInvoice = 'incomingInvoice',
  MyCustomIncomingInvoice = 'myCustomIncomingInvoice',
  IncomingDespatchAdvice = 'incomingDespatchAdvice',
  MyCustomIncomingDespatchAdvice = 'myCustomIncomingDespatchAdvice'
}

export enum SearchPartySourceType {
  CreatePage = 'createPage',
  FilterPopup = 'filterPopup'
}

export enum DocumentCurrencyCode {
  TL = 'TL',
  TRY = 'TRY',
  EUR = 'EUR',
  USD = 'USD',
  GBP = 'GBP'
}

export enum NumberPrefixDocumentType {
  Invoice = 1,
  E_ArchiveInvoice = 2,
  DespatchAdvice = 3,
  E_Receipt = 4,
  ReceiptAdvice = 5,
  E_Smm = 6,
  Ticket = 7,
  PassengerList = 8
}

export enum TaxTotalType {
  KDV = '0015',
  GVSTOPAJ = '0003',
  MERAFONU = '9040',
  SGKKESINTISI = 'SGK_PRIM',
  BORSATESCIL = '8001'
}

export enum DraftDocumentType {
  Invoice = 1,
  DespatchAdvice = 2,
  CreditNote = 3,
  ESMM = 4,
  ExpenseVoucher = 5
}

export enum DocumentCreateSourceType {
  None = '',
  UpdateDocument = 'updateDocument',
  CreateCopy = 'createCopy',
  CreateReturnInvoice = 'createReturnInvoice'
}

export enum DocumentGridListType {
  ListPage = 'listPage',
  GlobalSearch = 'globalSearch'
}
